/**
 * NO04 - Ordre Search API Calls
 */

import axios, { AxiosRequestConfig } from 'axios';
import { NO04SearchParams } from '../models/NO04';
import Utils from './Utils';
import CSharpUtils from './CSharpUtils';

const timeout = 30000;

export const searchOrders = (searchParams: NO04SearchParams) => {
  const backendParams: any = {
    CompanyId: searchParams.companyId,
    Page: searchParams.page ?? 0,
    PageSize: searchParams.pageSize ?? 100,
  };

  if (searchParams.orderNumber)         backendParams.OrderNumber         = searchParams.orderNumber;
  if (searchParams.customerNumber)      backendParams.CustomerNumber      = searchParams.customerNumber;
  if (searchParams.requisitionNumber)   backendParams.RequisitionNumber   = searchParams.requisitionNumber;
  if (searchParams.productId)           backendParams.ProductId           = searchParams.productId;
  if (searchParams.invoiceCreditNumber) backendParams.InvoiceCreditNumber = searchParams.invoiceCreditNumber;
  if (searchParams.receiver)            backendParams.Receiver            = searchParams.receiver;
  if (searchParams.address)             backendParams.Address             = searchParams.address;
  if (searchParams.fromDate)            backendParams.From                = searchParams.fromDate;
  if (searchParams.toDate)             backendParams.To                  = searchParams.toDate;

  const config: AxiosRequestConfig = {
    method: 'get',
      baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orders/summary`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: backendParams,
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};

export const getInvoicePDF = (companyId: string, invoiceNumb: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    url: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/invoices/pdf`,
    timeout,
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${CSharpUtils.Get_Token}`,
    },
    params: { companyId, invoiceNumb },
    responseType: 'blob',
  };
  return axios.request(config);
};

export const fetchOrderDetail = (companyId: number, orderNumber: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
      baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/Order/detail`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: { orderNumber, companyId },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};

// Batch order-line lookup for the "Med ordrelinjer" export — one request for the whole
// selection instead of one fetchOrderDetail call per order (see GetOrderLinesForExportHandler).
// `orders` carries (recordType, orderNumber) so the backend returns exactly these orders —
// order numbers are recycled across years, and the number alone can match another year's order.
export const fetchOrderLinesForExport = (companyId: number, orders: { orderNumber: string; recordType: string }[]) => {
  const config: AxiosRequestConfig = {
    method: 'post',
    baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orders/lines-for-export`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    data: { companyId: String(companyId), orderNumbers: orders.map((o) => o.orderNumber), orders },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};

export const fetchOrderLog = (companyId: string, orderNumber: string) => {
  const config: AxiosRequestConfig = {
    method: 'get',
    baseURL: `${Utils.URL_ADDRESS}${Utils.WEBAPI_PATH}/orders/log`,
    timeout,
    headers: {
      'content-type': 'application/json',
      Authorization: 'Bearer ' + sessionStorage.getItem('token'),
    },
    params: { companyId, orderNumber },
    responseType: 'json',
    responseEncoding: 'utf8',
    withCredentials: false,
  };
  return axios.request(config);
};
